import { render, staticRenderFns } from "./SplitList.vue?vue&type=template&id=eadfd52c&scoped=true"
import script from "./SplitList.vue?vue&type=script&lang=js"
export * from "./SplitList.vue?vue&type=script&lang=js"
import style0 from "./SplitList.vue?vue&type=style&index=0&id=eadfd52c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eadfd52c",
  null
  
)

export default component.exports